/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ locale: NonNullable<unknown> }} Blog_Website_Locale_SlugInputs */

const cs_blog_website_locale_slug = /** @type {(inputs: Blog_Website_Locale_SlugInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Slug pro ${i?.locale} — nastavte pro každý jazyk v záložkách nahoře.`)
};

const en_blog_website_locale_slug = /** @type {(inputs: Blog_Website_Locale_SlugInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Slug for ${i?.locale} — set per language in the tabs above.`)
};

/**
* | output |
* | --- |
* | "Slug for {locale} — set per language in the tabs above." |
*
* @param {Blog_Website_Locale_SlugInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_website_locale_slug = /** @type {((inputs: Blog_Website_Locale_SlugInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Website_Locale_SlugInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_website_locale_slug(inputs)
	return cs_blog_website_locale_slug(inputs)
});